export default [
  {
    label: '阿里云图标',
    list: [
      'icon-dianreshuiqi-jiadia',
      'icon-jichengzao-jiadian',
      'icon-lishikongtiao-jiadian',
      'icon-kaoxiang-jiadian',
      'icon-kongtiao-jiadian',
      'icon-reshuiqi-jiadian',
      'icon-wujin-jiadian',
      'icon-bingxiang-jiadian',
      'icon-greasepump-jiadian',
      'icon-xiaodugui-jiadian',
      'icon-dianshiji-jiadian',
      'icon-zaoju-jiadian',
      'icon-pinpaijiadian-jiadian',
      'icon-yushiyongpin-jiadian',
      'icon-xiwanji-jiadian',
      'icon-binggui-jiadian',
      'icon-chugui2-jiadian',
      'icon-jiadian-jiadian',

      // 'icon-jiadian',
      'icon-xiyouyanji',
      'icon-shebeizaoju',
      'icon-liebiaotubiao_ranqireshuiqi-kai',
      // 'icon-liebiaotubiao_dianreshuiqi-kai',

      'icon-xiwanji-jiadian',
      // 'icon-kaoxiang-jiadian',
      // 'icon-zhengxiang',





      
    ]
  }
]
